import { render, staticRenderFns } from "./IntegrationsWidget.vue?vue&type=template&id=28739058&"
import script from "./IntegrationsWidget.vue?vue&type=script&lang=js&"
export * from "./IntegrationsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports